<ng-container *transloco="let t">
  <div class="spermogram-finding" [formGroup]="form">
    <div class="field">
      <label class="label">{{ t('spermogram.method') }}</label>
      <mat-form-field appearance="outline" class="w-full">
        <textarea matInput formControlName="method" rows="3"></textarea>
      </mat-form-field>
    </div>

    <div class="field">
      <label class="label">{{ t('spermogram.volume') }}</label>
      <mat-form-field appearance="outline" class="w-full">
        <textarea matInput formControlName="volume" rows="3"></textarea>
      </mat-form-field>
    </div>

    <div class="field">
      <label class="label">{{ t('spermogram.color') }}</label>
      <mat-form-field appearance="outline" class="w-full">
        <textarea matInput formControlName="color" rows="3"></textarea>
      </mat-form-field>
    </div>

    <div class="field">
      <label class="label">{{ t('spermogram.smell') }}</label>
      <mat-form-field appearance="outline" class="w-full">
        <textarea matInput formControlName="smell" rows="3"></textarea>
      </mat-form-field>
    </div>

    <div class="field">
      <label class="label">{{ t('spermogram.consistency') }}</label>
      <mat-form-field appearance="outline" class="w-full">
        <textarea matInput formControlName="consistency" rows="3"></textarea>
      </mat-form-field>
    </div>

    <div class="field">
      <label class="label">{{ t('spermogram.bloodPresence') }}</label>
      <mat-form-field appearance="outline" class="w-full">
        <textarea matInput formControlName="bloodPresence" rows="3"></textarea>
      </mat-form-field>
    </div>

    <div class="field">
      <label class="label">{{ t('spermogram.otherImpurities') }}</label>
      <mat-form-field appearance="outline" class="w-full">
        <textarea
          matInput
          formControlName="otherImpurities"
          rows="3"
        ></textarea>
      </mat-form-field>
    </div>

    <div class="field">
      <label class="label">{{ t('spermogram.progressiveMotility') }}</label>
      <mat-form-field appearance="outline" class="w-full">
        <textarea
          matInput
          formControlName="progressiveMotility"
          rows="3"
        ></textarea>
      </mat-form-field>
    </div>

    <div class="field">
      <label class="label">{{ t('spermogram.slowMotile') }}</label>
      <mat-form-field appearance="outline" class="w-full">
        <textarea matInput formControlName="slowMotile" rows="3"></textarea>
      </mat-form-field>
    </div>

    <div class="field">
      <label class="label">{{ t('spermogram.dead') }}</label>
      <mat-form-field appearance="outline" class="w-full">
        <textarea matInput formControlName="dead" rows="3"></textarea>
      </mat-form-field>
    </div>

    <div class="field">
      <label class="label">{{ t('spermogram.agglutination') }}</label>
      <mat-form-field appearance="outline" class="w-full">
        <textarea matInput formControlName="agglutination" rows="3"></textarea>
      </mat-form-field>
    </div>

    <div class="field">
      <label class="label">{{ t('spermogram.opinion') }}</label>
      <mat-form-field appearance="outline" class="w-full">
        <textarea matInput formControlName="opinion" rows="3"></textarea>
      </mat-form-field>
    </div>

    <div class="field">
      <label class="label">{{ t('spermogram.note') }}</label>
      <mat-form-field appearance="outline" class="w-full">
        <textarea
          matInput
          formControlName="note"
          rows="3"
          placeholder="{{ t('Additional notes') }}"
        ></textarea>
      </mat-form-field>
    </div>

    <mat-form-field appearance="outline" class="w-full mb-3">
      <mat-label>{{ t('veterinarianName') }}</mat-label>
      <input matInput formControlName="veterinarianName" />
      <mat-error>{{ t('This field is required') }}</mat-error>
    </mat-form-field>
  </div>
</ng-container>
